import React from 'react';
import { Card, CardContent, Typography, Box, Avatar } from '@mui/material';

const StatsCard = ({ title, value, subtitle, icon, color }) => {
  return (
    <Card sx={{ height: '100%', boxShadow: 2 }}>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box>
            <Typography
              variant="h6"
              color="textSecondary"
              gutterBottom
              sx={{ fontSize: '0.875rem', fontWeight: 'medium' }}
            >
              {title}
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
              {value.toLocaleString()}
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ mt: 1, fontSize: '0.75rem' }}
            >
              {subtitle}
            </Typography>
          </Box>
          <Avatar
            sx={{
              bgcolor: color + '20', // Color con opacidad
              color: color,
              width: 48,
              height: 48,
            }}
          >
            {icon}
          </Avatar>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatsCard;